import { defineStore } from "pinia";
import { useAuthStore } from "./authStore";
import { useDsaReportsActivitiesStore } from "./dsaReportsActivitiesStore";
import { getDsaReportsIssuesById } from "../features/dsa-reports/api/dsaReportsApi";

export const useDsaReportsTicketsStore = defineStore("dsaReportsTicketsStore", {
  state: () => ({
    tickets: [],
    isLoading: false,
    error: null
  }),

  actions: {
    async fetchTicketsFromActivities() {
      const authStore = useAuthStore();
      const activityStore = useDsaReportsActivitiesStore();

      if (!authStore.token) {
        throw new Error("Authentication token is not available.");
      }

      try {
        this.isLoading = true;
        this.tickets = []; // Reset tickets

        // **Extract issue IDs from activityStore**
        const issueIds = Object.keys(activityStore.activitiesByIssue);
        if (issueIds.length === 0) {
          console.warn("No Issue IDs found in activities.");
          this.isLoading = false;
          return;
        }

        //console.log("Fetching tickets for Issues:", issueIds.join(","));

        // **Fetch tickets based on extracted issue IDs**
        const response = await getDsaReportsIssuesById({ issueId: issueIds.join(",") });

        let tickets = response.data;

        // ✅ **Replace `billable_Seconds` with `totalBillable` from activities**
        tickets = tickets.map(ticket => {
          const issueId = ticket.id; // ID of the ticket
          const activityData = activityStore.activitiesByIssue[issueId]; // Get activity data

          if (activityData) {
            ticket.billable_Seconds = Math.round(activityData.totalBillable * 3600); // Convert hours to seconds
          } else {
            ticket.billable_Seconds = 0; // Default to 0 if no matching data
          }

          return ticket;
        });

        this.tickets = tickets;
        //console.log("Updated Tickets with Activity Data:", this.tickets);

        this.error = null;
      } catch (err) {
        console.error("Error fetching tickets:", err);
        this.error = err.message;
        this.tickets = [];
      } finally {
        this.isLoading = false;
      }
    },

    clearTickets() {
      //console.log("Clearing ticket data.");
      this.tickets = [];
    }
  },

  getters: {
    getTicketsByIssueId: (state) => (issueId) => {
      return state.tickets.filter(ticket => ticket.issueId === issueId);
    }
  }
});
